export default __webpack_public_path__ + "static/media/HomeImage.4e8c8aad.png";